exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#LoginComponent{width:70%;margin-top:60px}#LoginComponent h1{color:#4286c7}#LoginComponent .white{color:#fff}#LoginComponent .small-text,#LoginComponent .small-text label{font-size:12px !important}#LoginComponent .forgotten{cursor:pointer;font-style:italic;color:#4286c7;padding-top:1rem;transition-duration:.4s;display:flex;align-items:center}#LoginComponent .forgotten:hover{color:#1b5892}", ""]);

// exports
